import React, { Component } from 'react';
import RoutingService from './services/routingService';
import HomePage from './Pages/Home/HomePage';
import { Routes, Route } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import PasswordChangePage from './Pages/PasswordChange/PasswordChangePage';
import ForCompaniesPage from './Pages/ForCompanies/ForCompaniesPage';
import TermsPage from './Pages/Terms/TermsPage';
import LogInPage from './Pages/LogIn/LogInPage';
import SignUpPage from './Pages/SignUp/SingUpPage';
import StatusPage from './Pages/Account/Status/StatusPage';
import Layout from './Pages/Layout/Layout';
import CookieConsent from "react-cookie-consent";

type AppProps = {
};

type AppState = {
};

class App extends Component<AppProps, AppState> {
    constructor(props: AppProps) {
        super(props);

        this.state = {
        };
    }

    public render() {
        return (
            <div className="App">
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path={RoutingService.getMainPageRoute()} element={<HomePage />} />
                            <Route path={RoutingService.getPasswordChangePageRoute()} element={<PasswordChangePage />} />
                            <Route path={RoutingService.getForCompaniesPageRoute()} element={<ForCompaniesPage />} />
                            <Route path={RoutingService.getTermsPageRoute()} element={<TermsPage />} />
                            <Route path={RoutingService.getLogInPageRoute()} element={<LogInPage />} />
                            <Route path={RoutingService.getSignUpPageRoute()} element={<SignUpPage />} />
                            <Route path={RoutingService.getUserAccountStatusPageRoute()} element={<StatusPage />} />
                        </Route>
                    </Routes>
                </BrowserRouter>

                <CookieConsent
                    location="bottom"
                    buttonText="Akceptuję"
                    cookieName="mojeCiasteczkoZgody"
                    style={{ background: "#2B373B", fontSize: "15px" }}
                    buttonStyle={{ color: "#4e503b", fontSize: "13px", borderRadius: "5px" }}
                    expires={150}
                >
                    Ta strona korzysta z ciasteczek, aby świadczyć usługi na najwyższym poziomie.{" "}
                    <span style={{ fontSize: "10px" }}>Kontynuując, zgadzasz się na ich użycie.</span>
                </CookieConsent>
            </div>


        );
    }
}

export default App;
